import { Text } from '@chakra-ui/react';

import asBentoPage from 'common/bento/hoc/asBentoPage';
import OBDocumentView from 'features/Bento/components/OBDocumentView';
import DocumentChecklist from 'features/Onboarding/components/DocumentChecklist';

import locales from './locales';

interface StatutesCheckProps {
  documentUrl: string;
  onValidate: () => void;
}

const StatutesCheck = asBentoPage<StatutesCheckProps>(
  ({ documentUrl, onPrev, onValidate }) => {
    return (
      <OBDocumentView onClose={onPrev} src={documentUrl}>
        <Text marginBottom="space-32">{locales.checkMessage}</Text>

        <DocumentChecklist
          checks={[
            {
              key: 'readable',
              label: locales.checkIsClear,
            },
          ]}
          isLoading={false}
          onSubmit={onValidate}
        />
      </OBDocumentView>
    );
  },
);

export default StatutesCheck;
